import { ONE_MINUTE_IN_MS } from '@/lib/constants';

export const REPORTING_STORE_API_BASE = 'api/v1/reporting-store';
export const INSIGHTS_TIMEOUT_MS = ONE_MINUTE_IN_MS;
